import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { connectionQueryKey } from './useConnection'
import { connectionsQueryKey } from './useConnections'

import type {
	Connection,
	UpdateConnection,
} from 'honeygrid-types/validators-and-types/ConnectionTypes'

interface UpdateConnectionParams {
	workspaceId?: string
	connectionId: Connection['uuid']
	connection: Partial<UpdateConnection>
}

export const useUpdateConnection = () => {
	const queryClient = useQueryClient()
	const authFetch = useHoneyGridApiFetch()

	return useMutation({
		mutationFn: async ({ workspaceId = '', connectionId, connection }: UpdateConnectionParams) => {
			if (!workspaceId) {
				toast.error('Workspace ID is required')
				throw new Error('Workspace ID is required')
			}
			return authFetch(`workspaces/${workspaceId}/connections/${connectionId}`, {
				method: 'PUT',
				body: connection,
			}) as Promise<Connection>
		},
		onSuccess: (_, { workspaceId, connectionId }) => {
			if (!workspaceId) {
				throw new Error('Workspace ID is required')
			}
			queryClient.invalidateQueries({
				queryKey: connectionsQueryKey(workspaceId),
			})
			queryClient.invalidateQueries({
				queryKey: connectionQueryKey(workspaceId, connectionId),
			})
		},
	})
}
